import { UrlSearch, UrlSearchProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

export type LensSubplaceParams = Readonly<{
  urlSearchValue: string;
}>;

export type DatasourceSubplaceParamsProviderProps = {
  readonly children: (params: LensSubplaceParams) => React.ReactNode;
};

export class LensSubplaceParamsProvider extends React.Component<DatasourceSubplaceParamsProviderProps> {

  public render() {
    return (
      <UrlSearchProvider>
        {urlSearch =>
          <LensSubplaceParamsProviderInternal urlSearch={urlSearch}>
            {this.props.children}
          </LensSubplaceParamsProviderInternal>
        }
      </UrlSearchProvider>
    );
  }

}

type LensSubplaceParamsProviderInternalProps = {
  readonly urlSearch: UrlSearch;
  readonly children: (params: LensSubplaceParams) => React.ReactNode;
};

class LensSubplaceParamsProviderInternal extends React.Component<LensSubplaceParamsProviderInternalProps> {

  public render() {
    return this.props.children({
      urlSearchValue: this.props.urlSearch.value,
    });
  }
}
